"use client";

import { c as _c } from "react/compiler-runtime";
import { ReactNode } from "react";
import { FiEyeOff } from "react-icons/fi";
import Button from "@/components/ui/button";
import { SortableDragHandle } from "@/components/ui/sortable-list";
import { useOverviewLayout } from "@/contexts/overview-layout-context";
import { OVERVIEW_SECTIONS } from "@/lib/overview-section-registry";
import { OverviewSection } from "@/types/overview-layout";
interface EditableSectionFrameProps {
  section: OverviewSection;
  children: ReactNode;
}
export default function EditableSectionFrame(t0) {
  const $ = _c(12);
  const {
    section,
    children
  } = t0;
  const {
    actions
  } = useOverviewLayout();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <SortableDragHandle />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== children) {
    t2 = <div className="pointer-events-none opacity-90 w-full">{children}</div>;
    $[1] = children;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== actions || $[4] !== section) {
    t3 = () => actions.hide(section);
    $[3] = actions;
    $[4] = section;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const t4 = `Hide ${OVERVIEW_SECTIONS[section].label}`;
  let t5;
  if ($[6] !== t3 || $[7] !== t4) {
    t5 = <Button variant="ghost" size="icon-sm" onClick={t3} icon={FiEyeOff} tooltip={t4} />;
    $[6] = t3;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t2 || $[10] !== t5) {
    t6 = <div className="rounded-lg border border-dashed border-border-secondary bg-background-secondary/30 p-3"><div className="mb-3 flex items-start justify-between gap-2">{t1}{t2}{t5}</div></div>;
    $[9] = t2;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  return t6;
}